module.exports = __webpack_public_path__ + "static/8-fa2e2fda1fc2baacd31a4703f7539e05.png";